<template>
  <div class="orderPoolTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button @click="save()" type="primary" class="vxe-btn-primary">{{
          $t('advanced.btnList.save')
        }}</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="orderPoolTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :loading="load"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'orderPoolTable',
    props: {
      tabItem: {
        type: Object,
      },
    },
    components: {},
    data() {
      return {
        tableData: [],
        load: false,
      };
    },
    computed: {
      //基础数据表单配置
      columnList() {
        return [
          {
            field: 'orderDate',
            title: this.$t('advanced.poolTable.orderDate'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderId',
            title: this.$t('advanced.poolTable.orderId'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderNo',
            title: this.$t('advanced.poolTable.orderNo'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          ...this[this.tabItem.optionName],
          {
            field: 'orderCompanyCode',
            title: this.$t('advanced.poolTable.orderCompanyCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderCompanyName',
            title: this.$t('advanced.poolTable.orderCompanyName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderDepartmentCode',
            title: this.$t('advanced.poolTable.orderDepartmentCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderDepartmentName',
            title: this.$t('advanced.poolTable.orderDepartmentName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          ...(['cashList', 'HNList'].indexOf(this.tabItem.optionName) != -1
            ? [
                {
                  // 是否允许修改
                  field: 'modifyAllowed',
                  title: this.$t('advanced.poolTable.modifyAllowed'),
                  editRender: {
                    name: 'ELInput',
                  },
                  slots: {
                    default: ({ row }) => {
                      return [<el-checkbox value={row.modifyAllowed}></el-checkbox>];
                    },
                    edit: ({ row }) => {
                      return [
                        <el-checkbox
                          onChange={(val) => this.modifyAllowedChange(val, row)}
                          value={row.modifyAllowed}
                        ></el-checkbox>,
                      ];
                    },
                  },
                },
              ]
            : []),
          {
            field: 'remark',
            title: this.$t('advanced.poolTable.remark'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 现金
      cashList() {
        return [
          {
            field: 'paymentAmount',
            title: this.$t('advanced.poolTable.paymentAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'receiptAmount',
            title: this.$t('advanced.poolTable.receiptAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 票据
      billList() {
        return [
          {
            field: 'billType',
            title: this.$t('advanced.billTable.billType'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderAmount',
            title: this.$t('advanced.poolTable.orderAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 信用证
      CLList() {
        return [
          {
            field: 'orderAmount',
            title: this.$t('advanced.poolTable.orderAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      // 海宁订单
      HNList() {
        return [
          {
            field: 'paymentAmount',
            title: this.$t('advanced.poolTable.paymentAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'receiptAmount',
            title: this.$t('advanced.poolTable.receiptAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderType',
            title: '订单类型',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'latestPerformanceDate',
            title: '最晚履约期',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'orderAmount',
            title: '订单金额',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'customerCode',
            title: this.$t('advanced.HNTable.customerCode'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'customerName',
            title: this.$t('advanced.HNTable.customerName'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      rules() {
        return {
          interestOrderCode: [
            {
              required: true,
              message: this.$t('interOrderType.table.interestOrderCodePlaceholder'),
            },
          ],
          interestOrderName: [
            {
              required: true,
              message: this.$t('interOrderType.table.interestOrderNamePlaceholder'),
            },
          ],
          implClass: [
            { required: true, message: this.$t('interOrderType.table.implClassPlaceholder') },
          ],
        };
      },
    },
    methods: {
      modifyAllowedChange(val, row) {
        row.modifyAllowed = val;
      },
      async getData(eventOrderId) {
        if (eventOrderId) {
          this.load = true;
          let res = await this.$axios.post(API[`QUERY_ORDER${this.tabItem.name.toUpperCase()}`], {
            eventOrderId,
          });
          if (res) {
            this.load = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data;
              this.tableData.map((item) => {
                item.modifyAllowed = item.modifyAllowed == 'Y' ? true : false;
              });
            }
          }
        } else {
          this.tableData = [];
        }
      },
      async save() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(
          API[`SAVE_ORDER${this.tabItem.name.toUpperCase()}`],
          params
        );
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      // 返回数据
      exportChildData() {
        const item = { ...this.$refs.orderPoolTable.getTableData().fullData[0] };
        // 点击提交，走校验
        return new Promise((resolve) => {
          this.$refs.orderPoolTable.validate((valid) => {
            if (valid) {
              item.modifyAllowed = item.modifyAllowed ? 'Y' : 'N';
              let param = {
                ...item,
              };
              resolve(param);
            }
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
